import { Injectable } from '@angular/core';
import { CohortDO } from '../../../../../common/domain-model-dtos';
import { AdminContextService } from '../../../../../common/services/admin.context.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LifetimeNetLossThresholdDTO, LifetimeRiskNetLossThresholdDTO } from './lifetime-net-loss-thresholds';
import { EDDCheckpointDTO } from '../affordability-settings/affordability-settings.model';

@Injectable({
  providedIn: 'root',
})
export class LifetimeNetLossThresholdsService {
  private currentCohort: CohortDO;

  constructor(
    private adminContextService: AdminContextService,
    private http: HttpClient
  ) {
    this.adminContextService.getCohortWatcher().subscribe((cohort) => {
      this.currentCohort = cohort;
    });
  }

  public get(): Observable<LifetimeRiskNetLossThresholdDTO[]> {
    return this.http.get<LifetimeRiskNetLossThresholdDTO[]>(`/player-activity/api/lifetimenetloss/thresholds`, {
      params: { currency: this.currentCohort.currency.code },
    });
  }
}
